/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiApprenticeshipRequest } from '../models/jofi-apprenticeship-request';
import { JofiApprenticeshipRequestsDto } from '../models/jofi-apprenticeship-requests-dto';
import { JofiCreateApprenticeshipRequestDto } from '../models/jofi-create-apprenticeship-request-dto';
import { JofiUpdateApprenticeshipRequestDto } from '../models/jofi-update-apprenticeship-request-dto';

@Injectable({
  providedIn: 'root',
})
export class JofiContentManagementApprenticeshipRequestsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apprenticeshipRequestsControllerFindAllMyRequestsAsStudent
   */
  static readonly ApprenticeshipRequestsControllerFindAllMyRequestsAsStudentPath = '/v1/content-management/apprenticeship-requests/student';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipRequestsControllerFindAllMyRequestsAsStudent()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerFindAllMyRequestsAsStudent$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiApprenticeshipRequestsDto>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipRequestsService.ApprenticeshipRequestsControllerFindAllMyRequestsAsStudentPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeshipRequestsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipRequestsControllerFindAllMyRequestsAsStudent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerFindAllMyRequestsAsStudent(params?: {
    context?: HttpContext
  }
): Observable<JofiApprenticeshipRequestsDto> {

    return this.apprenticeshipRequestsControllerFindAllMyRequestsAsStudent$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeshipRequestsDto>) => r.body as JofiApprenticeshipRequestsDto)
    );
  }

  /**
   * Path part for operation apprenticeshipRequestsControllerCreate
   */
  static readonly ApprenticeshipRequestsControllerCreatePath = '/v1/content-management/apprenticeship-requests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipRequestsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipRequestsControllerCreate$Response(params: {
    context?: HttpContext
    body: JofiCreateApprenticeshipRequestDto
  }
): Observable<StrictHttpResponse<JofiApprenticeshipRequest>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipRequestsService.ApprenticeshipRequestsControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeshipRequest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipRequestsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipRequestsControllerCreate(params: {
    context?: HttpContext
    body: JofiCreateApprenticeshipRequestDto
  }
): Observable<JofiApprenticeshipRequest> {

    return this.apprenticeshipRequestsControllerCreate$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeshipRequest>) => r.body as JofiApprenticeshipRequest)
    );
  }

  /**
   * Path part for operation apprenticeshipRequestsControllerAccept
   */
  static readonly ApprenticeshipRequestsControllerAcceptPath = '/v1/content-management/apprenticeship-requests/{id}/accept';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipRequestsControllerAccept()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerAccept$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiApprenticeshipRequest>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipRequestsService.ApprenticeshipRequestsControllerAcceptPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeshipRequest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipRequestsControllerAccept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerAccept(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiApprenticeshipRequest> {

    return this.apprenticeshipRequestsControllerAccept$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeshipRequest>) => r.body as JofiApprenticeshipRequest)
    );
  }

  /**
   * Path part for operation apprenticeshipRequestsControllerDecline
   */
  static readonly ApprenticeshipRequestsControllerDeclinePath = '/v1/content-management/apprenticeship-requests/{id}/decline';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipRequestsControllerDecline()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerDecline$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiApprenticeshipRequest>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipRequestsService.ApprenticeshipRequestsControllerDeclinePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeshipRequest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipRequestsControllerDecline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerDecline(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiApprenticeshipRequest> {

    return this.apprenticeshipRequestsControllerDecline$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeshipRequest>) => r.body as JofiApprenticeshipRequest)
    );
  }

  /**
   * Path part for operation apprenticeshipRequestsControllerWithdraw
   */
  static readonly ApprenticeshipRequestsControllerWithdrawPath = '/v1/content-management/apprenticeship-requests/{id}/withdraw';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipRequestsControllerWithdraw()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerWithdraw$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiApprenticeshipRequest>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipRequestsService.ApprenticeshipRequestsControllerWithdrawPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeshipRequest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipRequestsControllerWithdraw$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipRequestsControllerWithdraw(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiApprenticeshipRequest> {

    return this.apprenticeshipRequestsControllerWithdraw$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeshipRequest>) => r.body as JofiApprenticeshipRequest)
    );
  }

  /**
   * Path part for operation apprenticeshipRequestsControllerAddNote
   */
  static readonly ApprenticeshipRequestsControllerAddNotePath = '/v1/content-management/apprenticeship-requests/{id}/addNote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipRequestsControllerAddNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipRequestsControllerAddNote$Response(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdateApprenticeshipRequestDto
  }
): Observable<StrictHttpResponse<JofiApprenticeshipRequest>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipRequestsService.ApprenticeshipRequestsControllerAddNotePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeshipRequest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipRequestsControllerAddNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipRequestsControllerAddNote(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdateApprenticeshipRequestDto
  }
): Observable<JofiApprenticeshipRequest> {

    return this.apprenticeshipRequestsControllerAddNote$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeshipRequest>) => r.body as JofiApprenticeshipRequest)
    );
  }

}
